import { PALETTE as P } from "../tokens";

// Pre-reveal progress — the trial's anchor. Days 1–6 used to show a
// bare "3 of 7 check-ins so far." with no shape; this renders the same
// fact as a quiet dot ladder + "signals forming" so the first week has
// a visible destination. Counts CHECK-INS, not calendar days — the
// reveal actually unlocks at 7 check-ins (RevealGuard reads
// total_snapshots), so a day-based label would over- or under-promise.
//
// Renders nothing once the count reaches the threshold — the reveal
// flow owns everything from there.
export default function RevealCountdown({ count, total = 7 }) {
  const n = Math.max(0, Math.min(count ?? 0, total));
  if (n >= total) return null;
  return (
    <div aria-label={`Check-in ${n} of ${total} toward your first reading`}>
      <div style={{
        fontSize: 12.5, color: P.textMid, lineHeight: 1.55, fontWeight: 300,
      }}>
        Check-in {n} of {total} — signals forming.
      </div>
      <div style={{ display: "flex", gap: 5, marginTop: 7 }} aria-hidden="true">
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            style={{
              width: 6, height: 6, borderRadius: "50%",
              background: i < n ? P.primary : "transparent",
              border: `1px solid ${i < n ? P.primary : P.border}`,
              transition: "background 0.3s",
            }}
          />
        ))}
      </div>
      <div style={{ fontSize: 11, color: P.textFaint, marginTop: 7, fontWeight: 300 }}>
        Your first full reading unlocks at seven.
      </div>
    </div>
  );
}
